import styled from 'styled-components';

import theme from '../../assets/theme';
import { zIndexes } from '../../utils/zIndexes';

export const DesignerTopBarContainer = styled.div`
  height: 60px;
  width: 100%;
  background: ${theme.colors.creatorTopbarGradient};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  z-index: ${zIndexes('CREATOR_TOP_BAR')};
`;

export const DesignerTopBarContainerAnimated = styled.div`
  height: 60px;
  width: 100%;
  background: linear-gradient(-45deg, #ffc107, #ffa55b, #fff5d5, #ffa55b, #ffc107);
  background-size: 400% 400%;
  animation: gradient 4s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  z-index: ${zIndexes('CREATOR_TOP_BAR')};
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
